import React, { useState, useEffect, useRef } from "react";
import { motion, AnimatePresence } from "framer-motion";
import axios from "axios";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";

export default function SearchBox() {
    const [query, setQuery] = useState("");
    const [products, setProducts] = useState([]);
    const [openDropdown, setOpenDropdown] = useState(false);
    const searchRef = useRef();

    // Fetch products from API
    useEffect(() => {
        const trimmedQuery = (query || "").trim(); // Ensure string
        if (!trimmedQuery) {
            setProducts([]);
            return;
        }

        const fetchproducts = async () => {
            try {
                const { data } = await axios.get(
                    `${process.env.REACT_APP_API_URL}/api/v1/products/suggestions?q=${encodeURIComponent(
                        trimmedQuery
                    )}`
                );
                setProducts(data.products || []);
            } catch (err) {
                console.error(err);
            }
        };

        fetchproducts();
    }, [query]);

    // Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (e) => {
            if (searchRef.current && !searchRef.current.contains(e.target)) {
                setOpenDropdown(false);
            }
        };
        document.addEventListener("click", handleClickOutside);
        return () => document.removeEventListener("click", handleClickOutside);
    }, []);

    const dropVariants = {
        hidden: { opacity: 0, y: -10 },
        enter: { opacity: 1, y: 0, transition: { duration: 0.2 } },
        exit: { opacity: 0, y: -10, transition: { duration: 0.2 } },
    };


    const buildSearchUrl = (product) => {
        if (!product) return "";
        return `/${product.category}/${product.subCategory}/${product.slug}`;
    };


    return (
        <div
            className="search-wrapper position-relative w-100 mx-4"
            ref={searchRef}
            style={{ maxWidth: "720px" }}
        >
            <div
                className="search-box d-flex align-items-center shadow-sm bg-light"
                style={{
                    border: "1px solid #e5e5e5",
                    transition: "all 0.2s ease",
                    background: "#ffffff",
                }}
                onClick={(e) => e.stopPropagation()}
            >
                <input
                    className="form-control border-0 bg-transparent flex-grow-1 px-3 search-input"
                    placeholder="Search products, ingredients, rituals..."
                    value={query}
                    onChange={(e) => {
                        setQuery(e.target.value);
                        setOpenDropdown(true);
                    }}
                    onFocus={() => setOpenDropdown(true)}
                    style={{ fontSize: "15px", color: "#151515" }}
                />

                <motion.button
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                    onClick={() => window.open(buildSearchUrl(query), "_blank")}
                    className="btn search-btn d-flex align-items-center justify-content-center"
                    style={{
                        background: "#ffb100",
                        color: "#ffffff",
                        borderRadius: "0px",
                        width: "38px",
                        height: "38px",
                        border: "none",
                    }}
                >
                    <SearchOutlinedIcon sx={{ fontSize: 22 }} />
                </motion.button>
            </div>

            {/* products dropdown */}
            <AnimatePresence>
                {openDropdown && products.length > 0 && (
                    <motion.div
                        className="search-products shadow-sm bg-white w-100 mt-1"
                        initial="hidden"
                        animate="enter"
                        exit="exit"
                        variants={dropVariants}
                        style={{
                            position: "absolute",
                            top: "100%",
                            zIndex: 100,
                            border: "1px solid #ddd",
                            borderRadius: "4px",
                        }}
                    >
                        <ul className="list-unstyled mb-0">
                            {products && products.map((product, i) => {
                               return (
                                    <li
                                        key={i}
                                        className="suggestion-item py-2 px-2 rounded hover-bg"
                                        onClick={() => {
                                            setQuery(product.productName);
                                            setOpenDropdown(false);
                                            window.open(buildSearchUrl(product), "_blank");
                                        }}
                                        style={{ cursor: "pointer" }}
                                    >
                                        <a
                                            href={buildSearchUrl(product)}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="suggestion-link text-dark text-decoration-none d-block"
                                        >
                                            {product.productName}
                                        </a>
                                    </li>
                                )
                            })}
                        </ul>
                    </motion.div>
                )}
            </AnimatePresence>
        </div>
    );
}
